import React from 'react';

export interface EditUserModalProps {
  editingSystemUser: any;
  setEditingSystemUser: React.Dispatch<React.SetStateAction<any>>;
  handleSaveUserEdit: () => void;
}

export const EditUserModal: React.FC<EditUserModalProps> = ({
  editingSystemUser,
  setEditingSystemUser,
  handleSaveUserEdit,
}) => {
  if (!editingSystemUser) return null;

  return (
    <div className="fixed inset-0 z-[6000] bg-black/80 flex items-center justify-center p-4">
      <div className="bg-[#0a0e27] border border-[#00ffa3]/50 rounded-xl p-6 w-full max-w-md font-mono">
        <h3 className="text-sm font-bold mb-4 text-[#00ffa3] tracking-widest uppercase">
          {editingSystemUser.type === 'lead' ? 'Editar Lead' : 'Editar Usuário'}
        </h3>
        <div className="space-y-4">
          <div>
            <label className="text-[10px] text-white/50 uppercase">Email</label>
            <input type="text" value={editingSystemUser.email || editingSystemUser.stripe_customer_email || ''} placeholder="Sem e-mail no cadastro (preenchido no próximo login do usuário)" disabled className="w-full bg-black border border-white/10 p-2 text-sm rounded opacity-50 text-white placeholder:text-white/40" />
          </div>
          <div>
            <label className="text-[10px] text-white/50 uppercase">Nome</label>
            <input 
              type="text" 
              value={editingSystemUser.name || ''} 
              onChange={e => setEditingSystemUser({...editingSystemUser, name: e.target.value})} 
              className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
            />
          </div>
          <div>
            <label className="text-[10px] text-white/50 uppercase">Telefone</label>
            <input 
              type="text" 
              value={editingSystemUser.phone || ''} 
              onChange={e => setEditingSystemUser({...editingSystemUser, phone: e.target.value})} 
              className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
            />
          </div>
          {editingSystemUser.type !== 'lead' ? (
            <>
              <div>
                <label className="text-[10px] text-white/50 uppercase">CPF</label>
                <input 
                  type="text" 
                  value={editingSystemUser.cpf || ''} 
                  onChange={e => setEditingSystemUser({...editingSystemUser, cpf: e.target.value})} 
                  className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
                />
              </div>
              <div>
                <label className="text-[10px] text-white/50 uppercase">Chave de Licença</label>
                <input 
                  type="text" 
                  value={editingSystemUser.license_key || ''} 
                  onChange={e => setEditingSystemUser({...editingSystemUser, license_key: e.target.value})} 
                  className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
                  placeholder="FLOWAES-..."
                />
              </div>
            </>
          ) : (
            <>
              <div>
                <label className="text-[10px] text-white/50 uppercase">Empresa</label>
                <input 
                  type="text" 
                  value={editingSystemUser.company || ''} 
                  onChange={e => setEditingSystemUser({...editingSystemUser, company: e.target.value})} 
                  className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
                />
              </div>
              <div>
                <label className="text-[10px] text-white/50 uppercase">Detalhes</label>
                <input 
                  type="text" 
                  value={editingSystemUser.details || ''} 
                  onChange={e => setEditingSystemUser({...editingSystemUser, details: e.target.value})} 
                  className="w-full bg-black border border-white/30 p-2 text-sm rounded focus:border-[#00ffa3] outline-none text-white" 
                />
              </div>
            </>
          )}
          <div className="flex gap-4 mt-6">
            <button onClick={handleSaveUserEdit} className="flex-1 bg-[#00ffa3] text-black font-bold py-2 rounded text-xs tracking-wider">SALVAR</button>
            <button onClick={() => setEditingSystemUser(null)} className="flex-1 border border-white/30 text-white font-bold py-2 rounded text-xs tracking-wider">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>
  );
};
